import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=eed1cf8a&scoped=true&"
import script from "./addNotice.vue?vue&type=script&lang=ts&"
export * from "./addNotice.vue?vue&type=script&lang=ts&"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=eed1cf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed1cf8a",
  null
  
)

export default component.exports